import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

interface ClaroEmpresasHeaderProps {
  titulo: string;
  subtitulo?: string;
  dataReferencia?: Date;
  className?: string;
  children?: ReactNode;
}

export function ClaroEmpresasHeader({
  titulo,
  subtitulo,
  className,
  children,
}: ClaroEmpresasHeaderProps) {
  return (
    <div
      className={cn(
        "w-full flex h-14 rounded-lg overflow-hidden shadow-sm",
        // LIGHT: faixa bordô CHEIA original (user gostava).
        // DARK: card limpo com stripe lateral 4px bordô; titulo em off-white.
        "bg-primary dark:bg-card dark:border dark:border-border dark:border-l-4 dark:border-l-primary",
        className,
      )}
    >
      {/* Lado esquerdo - titulo */}
      <div className="flex flex-col justify-center px-6 shrink-0">
        <h1 className="text-lg md:text-xl font-bold tracking-tight whitespace-nowrap text-white dark:text-foreground">
          {titulo}
        </h1>
        {subtitulo && (
          <p className="text-xs text-white/80 dark:text-muted-foreground">{subtitulo}</p>
        )}
      </div>

      {/* Lado direito - conteúdo (slot) sobre a faixa bordô */}
      <div className="flex-1 min-w-0 flex items-center bg-primary dark:bg-transparent">
        {children}
      </div>
    </div>
  );
}
